import { AssetItem, Driver } from '../redux/types';
import { getVehicleNameOfAssetId } from './vehicleService';
import { getDriverNameOfDriverId } from './driverService';
import { DetailsSidebarDisplayItem } from '../../detailssidebar/types';

export const addDriverAndAssetInfoToDetailsSidebarDisplayItem = (
    displayItems: DetailsSidebarDisplayItem[],
    vehicles: AssetItem[],
    drivers: Driver[]
): DetailsSidebarDisplayItem[] => {
    return displayItems.map((displayItem) => {
        const resolvedDriverName = getDriverNameOfDriverId(displayItem.driverId, drivers);
        return {
            ...displayItem,
            vehicleName: getVehicleNameOfAssetId(displayItem.assetId, vehicles),
            driverName: resolvedDriverName ? resolvedDriverName : displayItem.driverName,
        };
    });
};
